<template>
  <div class="pli-refill-container">
    <div class="pli-refill-input-wrapper">
    <input
      type="checkbox"
      class="pli-refill-checkbox-input"
      :id="'subscribeCartCheckbox' + product.UUID"
      :checked="isSORSelected"
      :aria-label="smartOrderRefillContentAsset"
      @change="onInputValueChange($event)"
    />
    <label
      id="subscribeCartCheckboxLabel"
      class="pli-refill-checkbox-label form-check-label"
      :for="'subscribeCartCheckbox' + product.UUID"
    >
    </label>
    <div
      v-once
      class="pli-refill-content-asset"
      v-html="smartOrderRefillContentAsset"
    ></div>

    <button
      v-once
      :aria-label="$t('smartorderrefill.help.label')"
      data-toggle="modal"
      data-target="#osf-subscribe-toolkit"
      class="pli-refill-help-button"
    >
      <svg class="svg-icon">
        <use :href="`${svgPath}#info`" />
      </svg>
    </button>
    </div>

    <div
      v-if="product.refillOptions.monthIntervals.enabled && isSORSelected"
      class="pli-refill-period"
    >
      <div class="osf-cselect">
        <select
          class="pli-refill-period-select"
          name="SorDeliveryMonthInterval"
          id="sor-delivery-month-interval"
          :aria-label="$t('label.select.delivery.interval')"
          @change="onSelectedValueChange($event)"
        >
          <option
            v-for="option in product.refillOptions.monthIntervals.intervals"
            :value="option"
            :key="option"
            :selected="getSelectedPeriodicity(option, product)"
          >

            <span v-html="getProductRefillOptionLabel(
                option,
                product.refillOptions.recommendedInterval
              )"></span>
          </option>
        </select>
        <label class="form-control-placeholder" for="sor-delivery-month-interval" v-html="$t('label.select.delivery.interval')"></label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "ProductRefill",
  components: {},
  props: {
    productProps: {
      type: Object,
      required: true,
    },
  },
  watch: {
    productProps(newProduct) {
      this.product = newProduct;
    },
  },
  data() {
    return {
      selectedSOROption: "",
      checked: false,
      product: this.productProps,
      translate: this.$t.bind(this),
      isMiniCart: window.vueCurrentActiveStates['mini-cart'],
      isCart: window.vueCurrentActiveStates['cart']
    };
  },
  methods: {
    ...mapActions({
      sorUpdateProduct: "sorUpdateProduct",
    }),

    onInputValueChange(e) {
      if (e.target.checked) {
        let interval = this.product.refillOptions && this.product.refillOptions.recommendedInterval || 1;
        this.onSelectedValueChange({ target: { value: interval } });
      } else {
        this.productProps.hasSmartOrderRefill = false;
        this.product.hasSmartOrderRefill = false;

        var form = {
          action: "remove",
          hasSmartOrderRefill: this.product.hasSmartOrderRefill,
          SorDeliveryMonthInterval: 0,
          liuuid: this.product.UUID,
          intervalType: "month",
        };
        this.localSorUpdateProduct(form);
      }
    },
    onSelectedValueChange(e) {
      "onSelectedValueChange", e.target.value;

      this.selectedSOROption = e.target.value;
      this.productProps.hasSmartOrderRefill = true;
      this.product.hasSmartOrderRefill = true;

      var form = {
        action: "update",
        hasSmartOrderRefill: this.product.hasSmartOrderRefill,
        everyDelivery: "month",
        SorDeliveryMonthInterval: this.selectedSOROption,
        liuuid: this.product.UUID,
      };

      this.localSorUpdateProduct(form);
    },
    localSorUpdateProduct(form) {
      var bodyFormData = new FormData();

      for (var property in form) {
        bodyFormData.append(property, form[property]);
      }

      this.sorUpdateProduct(bodyFormData).then(() => {});
    },

    decoder(str) {
      var textArea = document.createElement("textarea");
      textArea.innerHTML = str;
      return textArea.value;
    },
    getProductRefillOptionLabel(option, isRecommended) {
      let delivers = this.translate("label.smartorderrefill.deliversevery");
      let months =
        option == 1
          ? this.translate("refill.multiple.month")
          : this.translate("refill.multiple.months");
      let recommended =
        option == isRecommended
          ? this.translate("label.smartorderrefill.product.recommeded.interval")
          : "";
      let labelText = delivers + " " + option + " " + months + recommended;
      return labelText;
    },
    getSelectedPeriodicity(option, product) {
      let isSelected =
        option === product.SorWeekInterval ||
        option === product.SorMonthInterval;
      return isSelected;
    },
  },
  computed: {
    isSORSelected: function () {
      return this.product.SorPeriodicity !== undefined &&
      this.product.SorPeriodicity !== null;
    },
    ...mapState(["svgPath"]),
    smartOrderRefillContentAsset: function () {
      let smartOrderRefill = this.translate("content.asset.smart.refill");
      let decoded = this.decoder(smartOrderRefill);
      return decoded;
    },
  },
  created() {
  },
};
</script>

<style >
</style>
